import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_AddressField = _resolveComponent("AddressField")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
        return (_openBlock(), _createBlock(_component_ion_item, {
          key: field.name
        }, {
          default: _withCtx(() => [
            (field.type!=='address')
              ? (_openBlock(), _createBlock(_component_ion_label, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(field.label), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (field.type==='address')
              ? (_openBlock(), _createBlock(_component_AddressField, {
                  key: 1,
                  value: _ctx.values[field.name],
                  onChange: ($event: any) => (_ctx.values[field.name]=$event)
                }, null, 8, ["value", "onChange"]))
              : (_openBlock(), _createBlock(_component_ion_input, {
                  key: 2,
                  slot: "end",
                  modelValue: _ctx.values[field.name],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.name]) = $event),
                  disabled: _ctx.loading,
                  type: field.type
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "type"]))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ion_button, {
        disabled: _ctx.loading,
        color: "success",
        expand: "full",
        fill: "solid",
        type: "submit"
      }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('global.save')), 1))
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 32))
}